export default __webpack_public_path__ + "assets/images/8229b5133fc7519c41d08d4d4ec36c3a.jpg";